import { useRoutes } from 'react-router-dom';
import router from 'src/router';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import { CssBaseline } from '@mui/material';
import ThemeProvider from './theme/ThemeProvider';
import '../src/Styles/Login_reg.css';
import '../src/Styles/responsive.css';
import '../src/Styles/Dashboard.css';
import '../src/Styles/bind.css';
import '../src/Styles/index.css';

function App() {
  const content = useRoutes(router);
  return (
    <ThemeProvider>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <CssBaseline />

        {content}
      </LocalizationProvider>
    </ThemeProvider>
  );
}
export default App;
